import { React, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// Компоненты пользовательского интерфейса
import { useLoader } from './Common';
import CustomButton from '../CustomElements/CustomButton';
import Preloader from '../CustomElements/Preloader';

// компонент для отображения в модальном окне для удаления смежности

export default function ModalDelete({
  closeModal,
  confirmText,
  removalText,
  successText,
  goBackText = 'К списку',
  canDelete,
  onDelete,
  setParams,
  t
}) {
  const { isLoading, isSuccess } = useLoader();
  const params = useParams();

  useEffect(() => {
    if (params && setParams) {
      setParams(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="position-absolute"
      style={{ width: 'calc(100% - var(--sadr-font-size-20))', height: '100%', marginTop: '10px' }}
    >
      <h3 className="modal-title top-10">{`УДАЛЕНИЕ СМЕЖНОСТИ `}</h3>
      <div className="position-absolute top-50 start-50 translate-middle d-flex flex-column flex-nowrap align-items-center">
        {!isLoading && !isSuccess && (
          <>
            <h5 className="confirmation-title">{confirmText}</h5>
            <div className="modal-confirmation-btn-container">
              <CustomButton
                className="confirmation-btn confirm"
                width="var(--sadr-font-size-420)"
                height="var(--sadr-font-size-60)"
                text={t?.confirm || 'Подтвердить'}
                disabled={!canDelete}
                onClick={onDelete}
              />
              <CustomButton
                className="confirmation-btn cancel"
                width="var(--sadr-font-size-420)"
                height="var(--sadr-font-size-60)"
                color="var(--sadr-background-secondary)"
                colorText="var(--sadr-border)"
                text={t?.cancel || 'Отменить'}
                onClick={closeModal}
              />
            </div>
          </>
        )}
        {isLoading && (
          <>
            <h5 className="confirmation-title">{removalText}</h5>
            <Preloader isLoading />
          </>
        )}
        {isSuccess && (
          <>
            <h5 className="confirmation-title">{successText}</h5>
            <CustomButton
              className="confirmation-btn confirm"
              width="var(--sadr-font-size-420)"
              height="var(--sadr-font-size-60)"
              text={goBackText}
              onClick={closeModal}
            />
          </>
        )}
      </div>
    </div>
  );
}
